<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Backbutton />
                Профессиональный паспорт
            </div>
            <div class="content-inner">
                <div class="content-inner-left">
                    <div class="user_photo">
                        <img width="150" src="../../assets/img/1603570161_avatar2.jpg" />
                    </div>
                </div>
                <div class="content-inner-right">
                    <div class="header-for-input first-input-header">
                        Email: <b>{{user_data.email}}</b><br>
                        Фамилия: <b>{{user_data.surname}}</b><br>
                        Имя: <b>{{user_data.name}}</b><br>
                        Отчество: <b>{{user_data.third_name}}</b><br>
                    </div>
                </div>
                <hr />
                <div class="content-sub-header text_without_bold">Мероприятия / Диагностики</div>
                <table>
                    <tr>
                        <th>Наименование мероприятия</th>
                        <th>Корпоративный стандарт</th>
                        <th>Дата начала</th>
                        <th>Дата завершения</th>
                        <th>Результат оценки</th>
                    </tr>
                    <tr v-for="event in user_events" :key="event.id">
                        <td>{{ event.name }}</td>
                        <td>{{ event.corpstandart_name }}</td>
                        <td>{{ event.date_start }}</td>
                        <td>{{ event.date_end }}</td>
                        <td>{{ calculate_resault(event.resault, event.max_resault) }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .text_without_bold {
        font-style: normal !important;
    }
</style>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'Usercorpstandart',
    props: ['id'],
    components: {
        Leftmenu, Header, Backbutton, Success, Error
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            user_data: {},
            user_events: {}
        }
    },
    methods: {
        calculate_resault(resault, max_resault) {
            return (resault/max_resault*100).toFixed(2);
        },
        get_user_data() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/profpassport/'+this.id)
            .then(response => {
                this.user_data = response.data.data.user 
                this.user_events = response.data.data.events
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
    },
    created() {
        this.get_user_data()
    }
    
}
</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>